export default __webpack_public_path__ + "static/media/website.2c4fcb8f.png";